import { useCallback } from 'react';

import {
   Visit,
   VisitApplyTemplateCommand,
   VisitTemplate,
   VisitTemplateDetailType,
} from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';

import { useUpdateVisitCommand } from '../visitForm.hooks';
import { VisitFormController } from '../visitForm.types';
import { mapVisitToVisitFormBean } from '../visitForm.utils';

type ApplyVisitTemplateWithDraftSave = (
   templateId: VisitTemplate['id'],
   templateDetailTypes: VisitTemplateDetailType[]
) => Promise<void>;
type UseApplyVisitTemplateWithDraftSaveOptions = {
   visitId: Visit['id'];
   controller: VisitFormController;
};

type ApplyVisitTemplateCommandParameters = {
   templateId: VisitTemplate['id'];
   templateDetailTypes: VisitTemplateDetailType[];
};

export const useApplyVisitTemplateWithDraftSave = (
   options: UseApplyVisitTemplateWithDraftSaveOptions
): ApplyVisitTemplateWithDraftSave => {
   const { executeAsync: applyVisitTemplate } = useCqrsCommand<Visit, ApplyVisitTemplateCommandParameters>(
      (parameters) => {
         const command = new VisitApplyTemplateCommand();
         command.visitId = options.visitId;
         command.templateId = parameters.templateId;
         command.visitTemplateDetailTypes = parameters.templateDetailTypes;
         return command;
      }
   );
   const { executeAsync: updateVisit } = useUpdateVisitCommand(options.visitId);
   return useCallback(
      async (templateId, templateDetailTypes) => {
         await options.controller.handleSubmitDraft(async (formData) => {
            await updateVisit(formData);
            const visit = await applyVisitTemplate({
               templateId: templateId,
               templateDetailTypes: templateDetailTypes,
            });

            const value = mapVisitToVisitFormBean(visit);
            options.controller.setValue('interview', value.interview);
            options.controller.setValue('subjectiveAssessments', value.subjectiveAssessments);
            options.controller.setValue('recommendations', value.recommendations);
         })();
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [options.controller, updateVisit]
   );
};
